import Button from "../Button/Button";
import { ChevronLeft } from "../Icon/Icon";
import ConfigureFilter from "./ConfigureFilter/ConfigureFilter";
import {
  Filter,
  FilterConfiguration,
  FilterDrawerConfiguration,
} from "./types";
import styles from "./AddFilter.module.scss";

function AddFilter({
  configuration,
  onBack,
  onSave,
  selectedFilter,
  setSelectedFilter,
}: {
  configuration: FilterDrawerConfiguration[];
  onBack: () => void;
  onSave: (filter: Filter) => void;
  selectedFilter?: FilterConfiguration;
  setSelectedFilter: React.Dispatch<
    React.SetStateAction<FilterConfiguration | undefined>
  >;
}) {
  if (selectedFilter) {
    return (
      <ConfigureFilter
        options={selectedFilter}
        onBack={() => setSelectedFilter(undefined)}
        onSave={onSave}
      />
    );
  }

  return (
    <div>
      <Button
        variant="outline"
        size="xsmall"
        leftIcon={<ChevronLeft />}
        onClick={onBack}
      >
        Back
      </Button>
      <div className={styles.filterCategories}>
        {configuration.map((filterCategory) => (
          <section className={styles.filterCategory} key={filterCategory.title}>
            <h3 className={styles.filterCategoryTitle}>
              {filterCategory.title}
            </h3>
            <ul className={styles.filterCategoryOptions}>
              {filterCategory.configurations.map((config) => (
                <li key={config.name}>
                  <Button
                    variant="unstyled"
                    className={styles.filterCategoryOption}
                    onClick={() => setSelectedFilter(config)}
                  >
                    {config.label}
                  </Button>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}

export default AddFilter;
